import { Flex, useTheme, spacing } from '@fti/design-system';

interface WizardStepperProps {
  currentStep: number;
  totalSteps: number;
  stepLabels: string[];
  completedSteps: number[];
}

export function WizardStepper({
  currentStep,
  totalSteps,
  stepLabels,
  completedSteps,
}: WizardStepperProps) {
  const { theme } = useTheme();

  return (
    <Flex justify="between" align="start" style={{ marginBottom: spacing.lg }}>
      {stepLabels.map((label, index) => {
        const stepNum = index + 1;
        const isCompleted = completedSteps.includes(stepNum);
        const isCurrent = stepNum === currentStep;

        let bgColor = theme.colors.border.default;
        let textColor = theme.colors.text.secondary;
        if (isCurrent) {
          bgColor = 'transparent';
          textColor = theme.colors.primary[500];
        } else if (isCompleted) {
          bgColor = theme.colors.primary[500];
          textColor = theme.colors.text.inverse;
        }

        return (
          <Flex
            key={stepNum}
            direction="column"
            align="center"
            gap="xs"
            style={{ flex: 1 }}
          >
            <div
              style={{
                width: 32,
                height: 32,
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '0.85rem',
                fontWeight: 600,
                backgroundColor: bgColor,
                color: textColor,
                border: isCurrent
                  ? `2px solid ${theme.colors.primary[500]}`
                  : '2px solid transparent',
              }}
            >
              {isCompleted ? '\u2713' : stepNum}
            </div>
            <span
              style={{
                fontSize: '0.7rem',
                color: isCurrent
                  ? theme.colors.primary[500]
                  : theme.colors.text.secondary,
                fontWeight: isCurrent ? 600 : 400,
                textAlign: 'center',
              }}
            >
              {label}
            </span>
          </Flex>
        );
      })}
    </Flex>
  );
}
